<div class="fabricantes-page ds-page">
  <div class="fabricantes-loading-cover" *ngIf="carregando || ordenando" role="status" aria-live="polite">
  <div class="estado-carregando ds-loading-state">
    <app-loading-indicator></app-loading-indicator><span>Carregando fabricantes...</span>
  </div>
</div>
  <header class="ds-page-header fabricantes-header">
    <div class="ds-page-header-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/>
        <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01"/>
      </svg>
    </div>
    <div class="ds-page-header-copy">
      <h1 class="ds-page-title">Fabricantes</h1>
      <p class="ds-page-subtitle">Consulte fabricantes e atualize as margens utilizadas nos produtos.</p>
    </div>
    <div class="ds-page-actions">
      <button type="button" class="bt-novo" (click)="abrirNovo()" [disabled]="salvando || excluindo">Novo Fabricante</button>
      <button type="button" class="ds-btn ds-btn--no-icon" (click)="carregar()" [disabled]="carregando">
        <app-loading-indicator *ngIf="carregando" size="inline"></app-loading-indicator>
        {{ carregando ? 'Atualizando...' : 'Atualizar' }}
      </button>
    </div>
  </header>

  <main class="ds-page-content">
    <div *ngIf="erro" class="ds-alert ds-alert--danger">{{ erro }}</div>
    <div *ngIf="sucesso" class="ds-alert ds-alert--success">{{ sucesso }}</div>
    <div *ngIf="fabricantes.length && !verificacaoProdutosConcluida" class="ds-alert ds-alert--warning">
      Não foi possível verificar os produtos vinculados. A exclusão está indisponível até a verificação ser concluída.
    </div>

    <section class="fabricantes-resumo">
      <article class="ds-card resumo-card">
        <span class="resumo-icone resumo-icone--azul" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/>
          </svg>
        </span>
        <div><span class="resumo-label">Fabricantes cadastrados</span><strong>{{ fabricantes.length }}</strong></div>
      </article>
      <article class="ds-card resumo-card">
        <span class="resumo-icone resumo-icone--verde" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="m5 12 4 4L19 6"/><circle cx="12" cy="12" r="10"/>
          </svg>
        </span>
        <div><span class="resumo-label">Origem nacional</span><strong>{{ nacionais }}</strong></div>
      </article>
      <article class="ds-card resumo-card">
        <span class="resumo-icone resumo-icone--ambar" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15 15 0 0 1 0 20"/><path d="M12 2a15 15 0 0 0 0 20"/>
          </svg>
        </span>
        <div><span class="resumo-label">Origem internacional</span><strong>{{ internacionais }}</strong></div>
      </article>
    </section>

    <section class="ds-card fabricantes-card">
      <div class="ds-card-header fabricantes-toolbar">
        <div>
          <h2 class="ds-card-title">Cadastro de fabricantes</h2>
          <p>{{ fabricantesFiltrados.length }} registro(s) encontrados</p>
        </div>
        <div class="toolbar-filtros">
          <input class="ds-input ds-input--sm busca-fabricante" type="search" [(ngModel)]="busca"
            (ngModelChange)="alterarBusca()" placeholder="Buscar por código ou descrição" aria-label="Buscar fabricantes">
          <select class="ds-select filtro-origem" [(ngModel)]="origemFiltro" (ngModelChange)="alterarBusca()"
            aria-label="Filtrar por origem">
            <option value="">Todas as origens</option>
            <option value="NACIONAL">Nacional</option>
            <option value="INTERNACIONAL">Internacional</option>
          </select>
        </div>
      </div>

      <div *ngIf="carregando" class="estado-carregando ds-loading-state">
        <app-loading-indicator></app-loading-indicator><span>Carregando fabricantes...</span>
      </div>

      <div *ngIf="!carregando && !erro && !fabricantes.length" class="ds-empty-state">
        Nenhum fabricante encontrado.
      </div>

      <div class="ds-table-container ds-table-container--viewport-scroll fabricantes-tabela" *ngIf="!carregando && fabricantes.length">
        <table class="ds-table ds-table--sales ">
          <thead><tr>
            <th class="codigo-col" [attr.aria-sort]="sentidoOrdenacao('codigo')" (click)="ordenarPor('codigo')"><button type="button" class="ds-table-sort" [ngClass]="classeOrdenacao('codigo')" [disabled]="ordenando">Código</button></th>
            <th class="origem-col" [attr.aria-sort]="sentidoOrdenacao('origem')" (click)="ordenarPor('origem')"><button type="button" class="ds-table-sort" [ngClass]="classeOrdenacao('origem')" [disabled]="ordenando">Origem do produto</button></th>
            <th class="numero-col" [attr.aria-sort]="sentidoOrdenacao('custo')" (click)="ordenarPor('custo')"><button type="button" class="ds-table-sort" [ngClass]="classeOrdenacao('custo')" [disabled]="ordenando">Margem de custo</button></th>
            <th class="numero-col" [attr.aria-sort]="sentidoOrdenacao('lucro')" (click)="ordenarPor('lucro')"><button type="button" class="ds-table-sort" [ngClass]="classeOrdenacao('lucro')" [disabled]="ordenando">Margem de lucro</button></th>
            <th [attr.aria-sort]="sentidoOrdenacao('descricao')" (click)="ordenarPor('descricao')"><button type="button" class="ds-table-sort" [ngClass]="classeOrdenacao('descricao')" [disabled]="ordenando">Descrição</button></th>
            <th class="prazo-col" [attr.aria-sort]="sentidoOrdenacao('prazo')" (click)="ordenarPor('prazo')"><button type="button" class="ds-table-sort" [ngClass]="classeOrdenacao('prazo')" [disabled]="ordenando">Prazo para atualização</button></th>
            <th class="acoes-col">Ações</th>
          </tr></thead>
          <tbody>
            <tr class="fabricante-row" *ngFor="let fabricante of fabricantesPagina; trackBy: rastrearFabricante" (dblclick)="abrirEdicao(fabricante)">
              <td class="ds-text-muted codigo-col">{{ fabricante.CODIGO }}</td>
              <td><span class="ds-badge" [ngClass]="origemClasse(fabricante.AD_ORIGEM)">{{ origemLabel(fabricante.AD_ORIGEM) }}</span></td>
              <td class="ds-text-right ds-nowrap">{{ exibirPercentual(fabricante.AD_CUSTO) }}<span *ngIf="fabricante.AD_CUSTO">%</span></td>
              <td class="ds-text-right ds-nowrap">{{ exibirPercentual(fabricante.AD_LUCRO) }}<span *ngIf="fabricante.AD_LUCRO">%</span></td>
              <td class="descricao-col"><strong>{{ fabricante.DESCRICAO || 'Sem descrição' }}</strong></td>
              <td class="ds-text-right ds-nowrap">{{ fabricante.AD_PRAZO_ATUAL_DIAS || '—' }}<span *ngIf="fabricante.AD_PRAZO_ATUAL_DIAS"> dias</span></td>
              <td class="ds-table-cell--actions" (click)="$event.stopPropagation()">
                <button type="button" class="ds-action-trigger" [class.ds-action-trigger--active]="dropdownAberto === fabricante.CODIGO"
                  (click)="toggleDropdown($event, fabricante.CODIGO)" (dblclick)="$event.stopPropagation()"
                  [attr.aria-label]="'Ações do fabricante ' + fabricante.DESCRICAO" [attr.aria-expanded]="dropdownAberto === fabricante.CODIGO" title="Ações">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
                </button>
                <div class="ds-dropdown-menu ds-dropdown-menu--flutuante" *ngIf="dropdownAberto === fabricante.CODIGO"
                  [style.position]="'fixed'" [style.top.px]="dropdownPos?.top" [style.right.px]="dropdownPos?.right" (click)="$event.stopPropagation()">
                  <button type="button" class="ds-dropdown-item ds-dropdown-item--primary" (click)="abrirEdicao(fabricante)" (dblclick)="$event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    Editar
                  </button>
                  <div class="ds-dropdown-divider"></div>
                  <button *ngIf="verificacaoProdutosConcluida && !fabricante.TEM_PRODUTOS" type="button" class="ds-dropdown-item ds-dropdown-item--danger" (click)="solicitarExclusao(fabricante)" (dblclick)="$event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m3 0-1 15H6L5 6m5 5v6m4-6v6"/></svg>
                    Excluir
                  </button>
                  <button *ngIf="fabricante.TEM_PRODUTOS || !verificacaoProdutosConcluida" type="button" class="ds-dropdown-item ds-dropdown-item--disabled" aria-disabled="true"
                    (click)="avisarExclusaoBloqueada(fabricante); fecharDropdown()" (dblclick)="$event.stopPropagation()"
                    [attr.aria-label]="'Exclusão indisponível para ' + fabricante.DESCRICAO"
                    [title]="fabricante.TEM_PRODUTOS ? 'Fabricante possui produtos cadastrados' : 'Não foi possível verificar os produtos vinculados'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m3 0-1 15H6L5 6"/></svg>
                    Excluir
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="fabricantesFiltrados.length === 0"><td colspan="7" class="ds-table-empty">Nenhum fabricante corresponde aos filtros.</td></tr>
          </tbody>
        </table>
      </div>

      <footer class="ds-table-footer" *ngIf="!carregando && fabricantesFiltrados.length" aria-label="Paginacao de fabricantes">
        <span class="ds-table-footer-total">{{ fabricantesFiltrados.length }} fabricante(s)</span>
        <div class="ds-table-footer-controls">
          <div class="ds-page-size"><span>Exibir</span>
            <select class="ds-page-size-select" [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()">
              <option *ngFor="let quantidade of opcoesPorPagina" [ngValue]="quantidade">{{ quantidade }}</option>
            </select><span>por p&aacute;gina</span>
          </div>
          <div class="ds-page-buttons">
            <button type="button" class="ds-page-button" (click)="irParaPagina(1)" [disabled]="pagina === 1" title="Primeira">&laquo;</button>
            <button type="button" class="ds-page-button" (click)="irParaPagina(pagina - 1)" [disabled]="pagina === 1" title="Anterior">&lsaquo;</button>
            <button *ngIf="paginas[0] > 1" type="button" class="ds-page-button ds-page-button--ellipsis" disabled>&hellip;</button>
            <button *ngFor="let numeroPagina of paginas" type="button" class="ds-page-button" [class.ds-page-button--active]="numeroPagina === pagina" (click)="irParaPagina(numeroPagina)">{{ numeroPagina }}</button>
            <button *ngIf="paginas[paginas.length - 1] < totalPaginas" type="button" class="ds-page-button ds-page-button--ellipsis" disabled>&hellip;</button>
            <button type="button" class="ds-page-button" (click)="irParaPagina(pagina + 1)" [disabled]="pagina === totalPaginas" title="Proxima">&rsaquo;</button>
            <button type="button" class="ds-page-button" (click)="irParaPagina(totalPaginas)" [disabled]="pagina === totalPaginas" title="Ultima">&raquo;</button>
          </div>
        </div>
      </footer>
    </section>
  </main>
</div>

<div class="ds-modal-overlay" *ngIf="formularioAberto" (click)="fecharFormulario()">
  <section class="ds-modal fabricante-modal" role="dialog" aria-modal="true" aria-labelledby="fabricante-modal-title" (click)="$event.stopPropagation()">
    <header class="ds-modal-header">
      <div><span class="fabricante-kicker">{{ criando ? 'NOVO FABRICANTE' : 'FABRICANTE #' + selecionado?.CODIGO }}</span>
        <h2 class="ds-modal-title" id="fabricante-modal-title">{{ criando ? 'Cadastrar fabricante' : form.descricao }}</h2>
        <p>Dados cadastrais e margens do fabricante</p>
      </div>
      <button type="button" class="ds-modal-close" aria-label="Fechar" (click)="fecharFormulario()">×</button>
    </header>
    <div class="ds-modal-body fabricante-form">
      <div *ngIf="erroModal" class="ds-alert ds-alert--danger">{{ erroModal }}</div>
      <div class="ds-form-grid fabricante-campos">
        <label class="ds-field" *ngIf="!criando"><span class="ds-label">Código</span><input class="ds-input" [value]="selecionado?.CODIGO" disabled></label>
        <label class="ds-field campo-descricao"><span class="ds-label ds-label-obrigatorio">Descrição</span><input class="ds-input" [(ngModel)]="form.descricao" maxlength="100" autocomplete="off"></label>
        <label class="ds-field"><span class="ds-label">Margem de Custo (%)</span><input class="ds-input" type="number" step="0.01" [(ngModel)]="form.margemCusto"></label>
        <label class="ds-field"><span class="ds-label">Margem de Lucro (%)</span><input class="ds-input" type="number" step="0.01" [(ngModel)]="form.margemLucro"></label>
        <label class="ds-field"><span class="ds-label ds-label-obrigatorio">Origem do Produto</span><select class="ds-select" [(ngModel)]="form.origem"><option value="NACIONAL">Nacional</option><option value="INTERNACIONAL">Internacional</option></select></label>
        <label class="ds-field"><span class="ds-label ds-label-obrigatorio">Prazo Para Atualização</span><div class="prazo-valor"><input class="ds-input" type="number" step="1" [(ngModel)]="form.prazoAtualizacao"><span>dias</span></div></label>
      </div>
    </div>
    <footer class="ds-modal-footer">
      <button type="button" class="bt-cancelar" (click)="fecharFormulario()" [disabled]="salvando">Cancelar</button>
      <button type="button" class="bt-salvar" (click)="salvar()" [disabled]="salvando">
        <app-loading-indicator *ngIf="salvando" size="inline"></app-loading-indicator>{{ salvando ? 'Salvando...' : (criando ? 'Cadastrar fabricante' : 'Salvar alterações') }}
      </button>
    </footer>
  </section>
</div>

<div class="ds-modal-overlay" *ngIf="acaoPendente" (click)="cancelarConfirmacao()">
  <section class="ds-modal ds-modal--sm fabricante-confirmacao" role="dialog" aria-modal="true" aria-labelledby="confirmacao-fabricante-title" (click)="$event.stopPropagation()">
    <header class="ds-modal-header">
      <h2 class="ds-modal-title" id="confirmacao-fabricante-title">Excluir fabricante</h2>
      <button type="button" class="ds-modal-close" aria-label="Fechar" (click)="cancelarConfirmacao()">×</button>
    </header>
    <div class="ds-modal-body">
      <p>Confirma a exclusão do fabricante <strong>{{ acaoPendente.fabricante.DESCRICAO }}</strong> (código {{ acaoPendente.fabricante.CODIGO }})?</p>
    </div>
    <footer class="ds-modal-footer">
      <button type="button" class="bt-cancelar" (click)="cancelarConfirmacao()" [disabled]="excluindo">Cancelar</button>
      <button type="button" class="bt-excluir" (click)="confirmarAcao()" [disabled]="excluindo">
        <app-loading-indicator *ngIf="excluindo" size="inline"></app-loading-indicator>
        {{ excluindo ? 'Excluindo...' : 'Excluir' }}
      </button>
    </footer>
  </section>
</div>


<div class="ds-modal-overlay" *ngIf="avisoExclusao" (click)="fecharAvisoExclusao()">
  <section class="ds-modal ds-modal--sm fabricante-confirmacao" role="dialog" aria-modal="true" aria-labelledby="aviso-exclusao-fabricante-title" (click)="$event.stopPropagation()">
    <header class="ds-modal-header">
      <h2 class="ds-modal-title" id="aviso-exclusao-fabricante-title">Exclusão indisponível</h2>
      <button type="button" class="ds-modal-close" aria-label="Fechar" (click)="fecharAvisoExclusao()">×</button>
    </header>
    <div class="ds-modal-body">
      <p *ngIf="avisoExclusao.motivo === 'produtos'">Fabricante possuí produtos cadastrados</p>
      <p *ngIf="avisoExclusao.motivo === 'nao-verificado'">Não foi possível verificar os produtos vinculados a este fabricante.</p>
    </div>
    <footer class="ds-modal-footer">
      <button type="button" class="bt-confirmar bt-sem-icone" (click)="fecharAvisoExclusao()">OK</button>
    </footer>
  </section>
</div>

